module.exports = __webpack_public_path__ + "static/media/5.9b4c6ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/5.jpg
// module id = 100
// module chunks = 0